<template>
  <div>
    <div class="row">
      <div>
        <api-header :id="id" tag="h4" class="flex flex-row items-center m-0">
          {{ $t('documentation.api.requestBody.title') }}
          <span class="grow" />
          <api-content-type-selector
            v-if="contentsTypes"
            :id="id + 'request-content-type'"
            :types="contentsTypes"
            @selected="idx => (contentIdx = idx)"
          />
        </api-header>
      </div>
    </div>
    <api-schema-object
      v-if="content && content.schema"
      :key="contentIdx"
      :type="callback ? 'payload' : 'request'"
      :schema="content.schema"
      :example-generator-args="content.exampleGeneratorArgs"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, PropType, ref } from 'vue';
import { Contents } from '@bifrost-dev-docs-mfe/common/types/apiDocs';
import ApiHeader from '@/components/api/content/common/ApiHeader.vue';
import ApiSchemaObject from '@/components/api/content/operations/schema/ApiSchemaObject.vue';
import ApiContentTypeSelector from '@/components/api/content/common/ApiContentTypeSelector.vue';

const props = defineProps({
  id: { type: String, required: true },
  contents: { type: Array as PropType<Contents>, required: true },
  callback: { type: Boolean, default: false },
});

const contentIdx = ref(0);
const contentsTypes = computed(() => props.contents.map(({ type }) => type));
const content = computed(() => props.contents[contentIdx.value]);
</script>
